<div class="eq-page">
  <div class="eq-container">
    <!-- Header -->
    <div class="eq-header">
      <div class="eq-logo">
        <i class="pi pi-building"></i>
      </div>
      <h1 class="eq-title">Exit Questionnaire</h1>
      <p class="eq-subtitle" *ngIf="questionnaire && !submitted">
        Thank you for your time at BISTEC Global, <strong>{{ questionnaire.employeeName }}</strong>.
        Your honest feedback helps us improve.
      </p>
    </div>

    <!-- Loading -->
    <div *ngIf="loading" class="eq-loading">
      <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
      <p>Loading questionnaire...</p>
    </div>

    <!-- Not found -->
    <div *ngIf="notFound && !loading" class="eq-not-found">
      <i class="pi pi-exclamation-triangle" style="font-size: 3rem; color: var(--color-warning)"></i>
      <h2>Questionnaire Not Found</h2>
      <p>This link may have expired or is invalid. Please contact your HR/P&C team if you believe this is an error.</p>
    </div>

    <!-- Already submitted -->
    <div *ngIf="submitted && !loading" class="eq-submitted">
      <i class="pi pi-check-circle" style="font-size: 3rem; color: var(--color-success, #22c55e)"></i>
      <h2>Thank You!</h2>
      <p>Your responses have been submitted successfully. We appreciate your feedback, <strong>{{ questionnaire?.employeeName }}</strong>.</p>
      <p class="eq-submitted-note">You may close this page.</p>
    </div>

    <!-- Questionnaire form -->
    <div *ngIf="questionnaire && !submitted && !loading" class="eq-form">
      <div *ngFor="let answer of questionnaire.answers; let i = index" class="eq-question">
        <label class="eq-question-label">
          <span class="eq-question-number">{{ i + 1 }}</span>
          {{ answer.question }}
        </label>
        <textarea pTextarea [(ngModel)]="answer.answer"
          [rows]="3" [autoResize]="true"
          placeholder="Type your answer here..."
          class="eq-answer-input"></textarea>
      </div>

      <div class="eq-actions">
        <p-button label="Submit Questionnaire" icon="pi pi-check"
          severity="primary" (onClick)="save()"
          [loading]="saving" [disabled]="!hasAnswers" />
      </div>

      <p class="eq-privacy-note">
        <i class="pi pi-lock"></i>
        Your responses are confidential and will only be reviewed by the P&C team.
      </p>
    </div>
  </div>
</div>
